<template>
  <div>جاري المعالجة...</div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const { mapActions } = createNamespacedHelpers('AuthenticationModule');

export default {
  name: 'AuthCallback',
  data() {
    return { message: 'جاري المعالجة...' };
  },
  mounted() {
    this.loginCallback()
      .then((redirectPath) => { this.callBackUrlRedirect(redirectPath); })
      .catch((err) => {
        console.error(err);
        console.log(localStorage);
        setTimeout(() => { location.reload(); }, 2000);
      });
  },
  methods: {
    ...mapActions({ loginCallback: 'oidcSignInCallback' }),
    callBackUrlRedirect(redirectPath) {
      redirectPath = redirectPath || '/';
      const path = redirectPath.split('#')[0];
      if (this.$route.path !== path)
        this.$router.push(path);
    },
  },
};
</script>
